import * as React from 'react';
import styled from 'styled-components';

import { SingleBlock } from '@process-advisor/process-miner/slicers/variants/singleBlock';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { Section } from '@process-advisor/process-miner/slicers/variants/section';
import { StepWidth } from '@process-advisor/process-miner/slicers/variants/stepWidth'
import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;

export const WorkflowOptions = React.memo(() => (
    <Wrapper>
        <SingleBlock width="20%">
            <Section title='Step Width'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <StepWidth/>
        </SingleBlock>
        <AlertMessage/>
    </Wrapper>
));
